import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=d8faeb0a&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=d8faeb0a&prod&lang=css"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=d8faeb0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8faeb0a",
  null
  
)

export default component.exports